const invertedMessages = {
  'Identity Verification': 'external.idp.identityVerification',
  Enabled: 'external.idp.status.enabled',
  Disabled: 'external.idp.status.disabled',
  Enable: 'external.idp.enable',
  Disable: 'external.idp.disable',
  Close: 'external.idp.header.close',
};

export default invertedMessages;
